import { LogisticsMode } from "@amzn/rttv_web_app/lib/shared/constants";
import { MIDDLE_MILE_AIR, PACKAGE_DELIVERY, SPD, LTL } from "../shared/strings/constants";

export const getLogsiticsModeEnum = (logisticsMode: string) => {
    switch(logisticsMode) {
        case (MIDDLE_MILE_AIR):
            return LogisticsMode[MIDDLE_MILE_AIR];
        case (SPD):
            return LogisticsMode[SPD];
        case (LTL):
            return LogisticsMode[LTL];

        default:
            return LogisticsMode[PACKAGE_DELIVERY];
    }
};